import { Tab } from "@headlessui/react";
import coins from "../../images/coins.svg";
import coin from "../../images/coin.svg";
import React, { FC, Fragment, useState, useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import { API_URL } from "../../api/config";
import { toast } from "react-toastify";
import emptybox from "../../images/emptybox.svg";
import emptycart from "../../images/emptycart.svg";
import bungalow from "../../images/bungalow.svg";
import { loadRazorpayScript } from "../../utils/razorpay";
import { AuthContext } from "context/userContext";

export interface AuthorPageProps {
  className?: string;
  ownerId?: any;
  direcCoins_wallet?: Number;
  ownerData?: any;
}

const AuthorPage: FC<AuthorPageProps> = ({
  className,
  ownerId,
  direcCoins_wallet,
  ownerData,
}) => {
  let [categories] = useState(["Transactions", "Top-ups"]);
  const [wallet_balance, setWallet_balance] = useState(0);
  const [selectedCoins, setSelectedCoins] = useState(0);
  const token = localStorage.getItem("token");
  const authContext = useContext(AuthContext);
  const { topUps, setTopUps, getTransactionDetails, transactions } = authContext;

  const coinsOptions = [
    { amount: 50, price: 119 },
    { amount: 100, price: 149 },
    { amount: 150, price: 199, popular: true },
    { amount: 200, price: 219 },
    { amount: 250, price: 249 },
    { amount: 300, price: 299 },
  ];
  useEffect(() => {
    setWallet_balance(ownerData?.direcCoins_wallet);
  }, [ownerData]);

  useEffect(() => {
    getTransactionDetails();
  }, [ownerId, categories]);

  const formatDateTime = (isoString: any) => {
    const date = new Date(isoString);

    return date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      day: "2-digit",
      month: "short",
    });
  };

  const renderSidebar = () => {
    // const handlePurchaseCoins = async (
    //   coinsToPurchase: number,
    //   amount: number
    // ) => {
    //   try {
    //     const razorpayLoaded = await loadRazorpayScript();
    //     if (!razorpayLoaded) {
    //       alert("Failed to load Razorpay. Please refresh and try again.");
    //       return;
    //     }

    //     const { data: order } = await axios.post(
    //       `${API_URL}/topUps/create-order`,
    //       { amount }
    //     );

    //     const options = {
    //       key: "rzp_test_TvFzc3FLtm08Ky",
    //       amount: order.amount,
    //       currency: order.currency,
    //       name: "DirektCoins",
    //       description: "Purchase Coins",
    //       order_id: order.id,
    //       prefill: { contact: ownerData.phoneNumber },
    //       notes: { email: ownerData?.email, coinsToPurchase, userId:ownerData?._id, userType:"owner" },
    //       handler: async () => {
    //         alert("Payment processing... Please wait.");
    //         let retryCount = 0;
    //         const maxRetries = 5;
    //         const interval = setInterval(async () => {
    //           try {
    //             const topUpsResponse = await axios.get(
    //               `${API_URL}/owner/get-topUps`,
    //               {
    //                 headers: {
    //                   token: token,
    //                 },
    //               }
    //             );
    //             const balanceResponse = await axios.get(
    //               `${API_URL}/owner/wallet-balance`,
    //               {
    //                 headers: {
    //                   token: token,
    //                 },
    //               }
    //             );
    //             if (topUpsResponse.data.error === false) {
    //               setTopUps(topUpsResponse.data.topUps);
    //               clearInterval(interval);
    //             } else if (topUpsResponse.data.error === true) {
    //               toast.error("Error fetching TopUps");
    //             }
    //             if (balanceResponse.data.error === false) {
    //               setWallet_balance(balanceResponse.data.balance);
    //               clearInterval(interval);
    //             } else if (balanceResponse.data.error === true) {
    //               toast.error("Error fetching wallet balance");
    //             }
    //             retryCount++;
    //             if (retryCount >= maxRetries) {
    //               clearInterval(interval); // Stop polling after max retries
    //             }
    //           } catch (error) {
    //             console.error("Error fetching updates:", error);
    //           }
    //         }, 5000);
    //       },
    //     };

    //     const razorpay = new (window as any).Razorpay(options);
    //     razorpay.open();
    //   } catch (error) {
    //     console.error("Error in payment flow:", error);
    //   }
    // };

    const handlePurchaseCoins = async (
      coinsToPurchase: number,
      amount: number
    ) => {
      toast.success(`We have received your request for the ${coinsToPurchase} coins!`);
    };

    return (
      <div className=" flex flex-col lg:flex-col items-center text-center sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-7 px-0">
        <div className="cardTop w-full lg:py-10 text-white rounded-t-2xl">
          <p className="mb-3.5 text-base font-medium">DirektCoins</p>
          <div className="coins flex justify-center items-center">
            <img src={coins} alt="coins" />
            <h2 className="text-5xl font-semibold">
              {wallet_balance || ownerData.direcCoins_wallet}
            </h2>
          </div>
          <p className="text-sm font-medium">Spending Balance</p>
        </div>
        <div className="cardBottom w-full lg:px-5">
          <ul className="w-full lg:px-5">
            {coinsOptions.map(({ amount, price, popular }) => (
              <li
                key={amount}
                onClick={() => setSelectedCoins(amount)}
                className={`flex justify-between border items-center rounded-xl lg:p-3 mb-3 cursor-pointer ${
                  selectedCoins === amount
                    ? "gradient-border-coins bg-white"
                    : ""
                }`}
              >
                <p className="text-sm pl-2 font-semibold">{amount} coins</p>
                {popular && (
                  <p
                    className="text-sm p-1 px-2 rounded-lg font-medium flex-none ml-2"
                    style={{ backgroundColor: "#B6F3F5" }}
                  >
                    Popular
                  </p>
                )}
                <p className="text-sm font-semibold flex-1 text-end self-center rupee">
                  ₹{price}
                </p>
              </li>
            ))}
          </ul>
          <div className="purchase-btn">
            <button
              onClick={() => {
                const selectedCoinOption = coinsOptions.find(
                  (option) => option.amount === selectedCoins
                );
                if (selectedCoinOption) {
                  handlePurchaseCoins(selectedCoins, selectedCoinOption.price);
                }
              }}
              className={`${
                selectedCoins
                  ? "bg-custom-color cursor-pointer"
                  : "bg-gray-500 cursor-default"
              } text-white text-sm px-5 py-3 rounded-3xl w-full font-medium lg:mb-5`}
            >
              Purchase DirektCoins
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap">
        <div>
          <h2 className="text-2xl font-semibold">Your Wallet Overview</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400 text-base">
            Browse your wallet transactions and top-ups.
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        <div>
          <Tab.Group>
            <Tab.List className="flex space-x-1 overflow-x-auto">
              {categories.map((item) => (
                <Tab key={item} as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`flex-shrink-0 block !leading-none font-medium px-5 py-2.5 text-sm sm:text-base sm:px-6 sm:py-3  rounded-full focus:outline-none ${
                        selected
                          ? "bg-custom-color text-secondary-50 "
                          : "text-neutral-500 dark:text-neutral-400 dark:hover:text-neutral-100 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                      } `}
                    >
                      {item}
                    </button>
                  )}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels>
              <Tab.Panel className="">
                 <div className="lg:mt-8 mt-5">
                  {transactions && transactions.length > 0 ? (
                    transactions.map((transaction: any) => (
                      <div className="transaction-list flex flex-col text-sm lg:py-5 py-3 border-b last:border-b-0">
                        <div className="transaction flex justify-between flex-none items-center">
                          <img
                            src={transaction.propId?.cover_image}
                            alt="property"
                            className="w-8 h-8 lg:w-10 lg:h-10 items flex-none mr-3 rounded-md"
                          />
                          <div className="transaction-details flex justify-between flex-1 items-center">
                            <div className="">
                              <h2 className="lg:text-base text-sm text-neutral-700 font-medium">
                                {transaction.propId?.title}
                              </h2>
                              <div className="flex text-neutral-500">
                                <p className="lg:text-sm text-xs">Mumbai</p>
                                <span
                                  style={{
                                    margin: "0 5px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  •
                                </span>
                                <p className="lg:text-sm text-xs">
                                  {formatDateTime(transaction.createdAt)}
                                </p>
                              </div>
                            </div>
                            <div className="flex flex-col justify-center items-center">
                              <div className="flex justify-center items-center">
                                <img src={coin} alt="coin" className="lg:w-6 w-5" />
                                <p className="lg:text-sm text-xs text-neutral-700">
                                  {transaction.propId?.coinsRequired}
                                </p>
                              </div>

                              <p className="lg:text-xs text-[11px] text-neutral-500">{`${direcCoins_wallet} left`}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="flex flex-col justify-center items-center">
                      <img src={emptybox} alt="empty box" />
                      <div className="my-5">
                        <h1 className="lg:text-lg text-base font-bold text-center">
                          No transactions
                        </h1>
                        <p className="lg:text-sm text-xs">
                          Looks like you don’t have any transactions!
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </Tab.Panel>
              <Tab.Panel className="">
                <div className="lg:mt-8">
                {topUps && topUps.length > 0 ? (
                    topUps.map((topUp: any) => (
                      <div className="topups-list flex text-sm justify-between items-center lg:py-5 py-3 border-b last:border-b-0">
                        <div className="flex flex-col">
                          <div className="flex items-center">
                            <img src={coin} alt="coin" className="lg:w-6 w-5 mr-2" />
                            <h2 className="lg:text-base text-sm text-neutral-700 font-medium">
                              {`${topUp.coins} Coins added`}
                            </h2>
                          </div>
                          <p className="lg:text-sm text-xs block text-neutral-500">
                            {`Purchased on ${formatDateTime(topUp.createdAt)}`}
                          </p>
                        </div>

                        <p className="lg:text-base text-sm text-neutral-700 font-medium rupee">
                          {`₹${topUp.amount}`}
                        </p>
                      </div>
                    ))
                  ) : (
                    <div className="flex flex-col justify-center items-center">
                      <img src={emptycart} alt="empty box" />
                      <div className="my-5">
                        <h1 className="text-lg font-bold text-center">
                          No top-ups
                        </h1>
                        <p className="text-sm">
                          Looks like you don’t have any spendings
                        </p>
                      </div>
                    </div>
                )}
                 
                </div>
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
    );
  };

  return (
    <div className={`nc-AuthorPage ${className}`} data-nc-id="AuthorPage">
      <Helmet>
        <title>DirektCoins || Homestays, PGs</title>
      </Helmet>
      <main className="container  mb-24 lg:mb-32 flex flex-col lg:flex-row">
        <div className="block flex-grow mb-24 lg:mb-0">
          <div className="lg:sticky lg:top-24 w-md">{renderSidebar()}</div>
        </div>
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
          {renderSection1()}
        </div>
      </main>
    </div>
  );
};

export default AuthorPage;
